module.exports = {
  CLEAN: 'clean',
  MODERATELY_CLEAN: 'moderately-clean',
  DIRTY: 'dirty',
  FILTHY: 'filthy',
};
